import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=704f5b66&scoped=true"
import script from "./Schedules.vue?vue&type=script&lang=js"
export * from "./Schedules.vue?vue&type=script&lang=js"
import style0 from "./Schedules.vue?vue&type=style&index=0&id=704f5b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f5b66",
  null
  
)

export default component.exports